import { type FunctionComponent } from 'react';

import { StyledUserInitial } from '../styles/styled-components';

interface UserImageProps {
    imgSource?: string;
    name: string;
}

const UserImage: FunctionComponent<UserImageProps> = ({ imgSource, name }) => {
    const initial = name.substring(0, 1).toUpperCase();
    const hasImageSource = (imgSource && imgSource.trim() !== '');

    return (
        <>
            {hasImageSource ? <img src={imgSource} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 10 }} /> : <StyledUserInitial>{initial}</StyledUserInitial>}
        </>
    );
};

export default UserImage;
